import { useEffect, useState } from 'react';
import CourseDetailsApi from '../Api/CourseDetailsApi';

/**
 * ? Información de retorno del hook.
 * @typedef {Object} CourseData
 * @property {import('Api/Request/Course/findOneCourse').CourseData} course Información del curso.
 * @property {boolean} loading Estado de carga.
 */

/**
 * ? Hook para pantalla del detalle de un curso, obtiene toda la información del curso necesaria.
 * @param {Object} params Parámetros de configuración.
 * @param {string} params.courseId ID del curso a consultar.
 * @returns {CourseData} Información del curso y estado de carga.
 */
const useCourseDetailsApi = ({ courseId } = {}) => {
  // Información del curso especifico.
  const [course, setCourse] = useState();
  // Arranca en carga cuando hay un id: la cabecera ya no recibe datos por
  // location.state, así que sin esto pintaría un frame en blanco.
  const [loading, setLoading] = useState(!!courseId);

  // Función para leer la información de un curso específico.
  const readCourseInformation = async () => {
    setLoading(true);
    // LLamada a la API para obtener la información del curso.
    CourseDetailsApi.readOne(courseId).then(response => {
      setCourse(response?.findOneCourse);
      setLoading(false);
    });
  };

  useEffect(() => {
    // Si no se proporciona el "courseId" se leen todos.

    if (!courseId) {
      return;
    }
    // Se lee la información del curso.
    readCourseInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId]);

  return {
    course,
    loading,
  };
};

export default useCourseDetailsApi;
